export function initAnchor(){
    // Получаем все якорные ссылки
    const anchorLinks: NodeListOf<HTMLAnchorElement> = document.querySelectorAll('.anchor');

    anchorLinks.forEach(link => {
        link.addEventListener('click', (e: Event) => {
            e.preventDefault(); // отменяем стандартный переход

            const targetId = link.getAttribute('href')?.substring(1); // убираем #
            if (!targetId) return;

            const targetElement = document.getElementById(targetId);
            if (!targetElement) return;

            // Получаем фиксированный хедер
            const header = document.querySelector<HTMLElement>('.header');
            const headerHeight = header ? header.offsetHeight : 0;

            // Вычисляем позицию для скролла
            const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY - 20;
            const offsetPosition = elementPosition - headerHeight;

            // Плавный скролл
            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth',
            });
        });
    });

}